import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'

export const partSuppliersPivotTableKey = 'priceListsContext.part.partSuppliers.pivotTable'

export default combineReducers({
    pivotTable: createPivotTableReducer({
        key: partSuppliersPivotTableKey,
        defaultSortColumn: 'default',
        defaultSortDirection: 'desc',
        pageSize: 50,
        defaultGridStretch: false,
        defaultAreAllRowsSelected: false,
        defaultCanSelectRows: false,
        retainEdits: false,
    }),
})
